import * as constants from "../constants/translator";

export const initialState = {
  settings: {
    code: "en",
    label: "English",
    reversed: false,
    type: constants.ENGLISH_TO_GEORDIE,
    text: ""
  },
  loadingTranslation: false,
  translatedText: "",
  showLanguageMenu: false,
  showShareMenu: false
};

const getSettingsType = (code, reversed) => {
  if (code === "en" && reversed === false) {
    return constants.ENGLISH_TO_GEORDIE;
  }

  if (code !== "en" && reversed === false) {
    return constants.NON_ENGLISH_TO_GEORDIE;
  }

  if (code === "en" && reversed) {
    return constants.GEORDIE_TO_ENGLISH;
  }

  return constants.GEORDIE_TO_NON_ENGLISH;
};

const translator = (state = initialState, action = {}) => {
  switch (action.type) {
    case constants.TRANSLATE_TEXT: {
      return Object.assign({}, state, {
        settings: {
          ...action.data
        }
      });
    }
    case constants.SET_TRANSLATED_TEXT: {
      return Object.assign({}, state, {
        loadingTranslation: false,
        translatedText: action.text
      });
    }
    case constants.TRANSLATION_LOADING: {
      return Object.assign({}, state, {
        loadingTranslation: true
      });
    }
    case constants.SELECT_LANGUAGE: {
      const reversed = state.settings.reversed;
      const code = action.code;
      return Object.assign({}, state, {
        settings: {
          ...state.settings,
          label: action.name,
          code,
          type: getSettingsType(code, reversed)
        },
        showLanguageMenu: false
      });
    }
    case constants.SWAP_SELECTED_LANGUAGES: {
      const reversed = !state.settings.reversed;
      const code = state.settings.code;
      return Object.assign({}, state, {
        settings: {
          ...state.settings,
          reversed,
          type: getSettingsType(code, reversed)
        }
      });
    }
    case constants.TOGGLE_LANGUAGE_MENU: {
      return Object.assign({}, state, {
        showLanguageMenu: !state.showLanguageMenu
      });
    }
    default: {
      return initialState;
    }
  }
};

export default translator;



// WEBPACK FOOTER //
// ./src/reducers/translator.js